import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { HomePageProvider } from './context/HomePageContext';
import Navigation from './components/Navigation';
import PasswordProtection from './components/PasswordProtection';
import HomePage from './pages/HomePage';
import ManufacturerPage from './pages/ManufacturerPage';
import ProductRankingPage from './pages/ProductRankingPage';
import ProductReviewsPage from './pages/ProductReviewsPage';
import ComparisonPage from './pages/ComparisonPage';
import ForumPage from './pages/ForumPage';
import AdminPage from './pages/AdminPage';
import UserDashboard from './pages/UserDashboard';
import SalePage from './pages/SalePage';
import ShopRatingPage from './pages/ShopRatingPage';
import VerifyEmail from './pages/VerifyEmail';
import ResetPassword from './pages/ResetPassword';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <HomePageProvider>
          <PasswordProtection>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <div className="App">
                <Navigation />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/manufacturer/:manufacturerId" element={<ManufacturerPage />} />
                  <Route path="/product/:id/suche" element={<ProductRankingPage />} />
                  <Route path="/product/:productId/reviews" element={<ProductReviewsPage />} />
                  <Route path="/comparison" element={<ComparisonPage />} />
                  <Route path="/sale" element={<SalePage />} />
                  <Route path="/shops" element={<ShopRatingPage />} />
                  <Route path="/forum" element={<ForumPage />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/profile" element={<UserDashboard />} />
                </Routes>
              </div>
            </Router>
          </PasswordProtection>
        </HomePageProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
